module.exports = "https://web-assets.ifttt.com/packs/media/shared/ifttt-banner-517eb701.png";